require('./init-global-components')

const ns = typeof window === 'undefined' ? global : window

ns.HelloBabyApp = require('./hello_baby/containers/HelloBabyApp').default

ns.ProductCollection =
  require('./hello_baby/components/ProductCollection').default

ns.ProductSpotlight =
  require('./hello_baby/components/ProductSpotlight').default

ns.PostConfettiBanner =
  require('./hello_baby/components/post-confetti-banner').default

ns.AuthorProfile = require('./hello_baby/components/AuthorProfile').default

ns.ReactRailsUJS = require('react_ujs')
